import React from "react";
import {
    VictoryAxis, VictoryChart, VictoryLabel, VictoryLine, VictoryScatter, VictoryTooltip, VictoryVoronoiContainer
} from "victory";
import theme from "../../../style/chartTheme";
import {baseFontFamily, baseFontSize, subduedTextColour} from "../../../style/styleConsts";

// see: https://jsfiddle.net/boygirl/ytq13Lfk/
class CustomLabel extends React.Component {
    render() {
        const label = this.props.text(this.props.datum);
        return (
            <g>
                <VictoryLabel {...this.props} text={label.substr(0, 5) + "."}/>
                <VictoryTooltip {...this.props}
                                text={label}
                                style={{fill: "white", fontFamily: baseFontFamily, fontSize: baseFontSize}}
                                flyoutStyle={{strokeWidth: 0, fill: subduedTextColour}}/>
            </g>
        );
    }
}
CustomLabel.defaultEvents = VictoryTooltip.defaultEvents;

const range =  values => (values.length === 0) ? [] : [Math.min(...values), Math.max(...values)];

function rangeOf(sectorsAndVolumes) {
    return range(sectorsAndVolumes.filter(noZeros).map(s => s.percentageOfOpenIdeas));
}

const noZeros = (sector) => sector && sector.percentageOfOpenIdeas;

function allPeriods (averages) {
    return [].concat.apply([], allPeriodsSeparately(averages));
}

function allPeriodsSeparately (averages) {
    return [averages.oneWeek, averages.oneMonth, averages.oneYear].filter(x => x);
}

export const sentimentRange = function (sectors) {
    return range([].concat(sectors.yourContributors, allPeriods(sectors.yourContributorsAverages))
                   .filter(noZeros).map(d=>d.percentageLong));
};
export const volumeShareRange = function (sectors) {
    const allRanges = [].concat(
        [sectors.yourContributors],
        allPeriodsSeparately(sectors.yourContributorsAverages)).map(rangeOf);
    return range([].concat.apply([], allRanges));
};

// TODO: tidy up by passing in just the identifier of the average and do the switching internally

export const prepareDataForChart = (sectors, previousAverage) => {
    const sectorData = sectors.yourContributors.filter(noZeros);
    const historicalData = (previousAverage || []).filter(noZeros);

    const percentageScaler = p => p * 100;
    const sectorScaler = s => ({...s, percentageLong: percentageScaler(s.percentageLong), percentageOfOpenIdeas: percentageScaler(s.percentageOfOpenIdeas) });
    const historicalDataScaled = historicalData.map(sectorScaler);
    const sectorDataScaled = sectorData.map(sectorScaler);

    const tails = historicalDataScaled.map(hd => {
        const sd = sectorDataScaled.find(s => s && s.name === hd.name);
        return sd ? [hd, sd] : null;
    }).filter(data => data);

    return {
        sectorData: sectorDataScaled,
        xDomain: sentimentRange(sectors).map(percentageScaler),
        yDomain: volumeShareRange(sectors).map(percentageScaler),
        tails: tails
    };
};

const SectorsBubbleChart = (props) => {
    const dataForChart = prepareDataForChart(props.sectors, props.previousAverage);

    // The chart renders at a visible size of 400x400, but there is an extra 20px above and to the right
    // that spill into the padding area of the parent to allow space for tooltips.
    return <div style={{width:420, height: 420, marginTop: -20, marginRight: -20}}>
             <VictoryChart theme={theme} width={420} height={420} padding={{top:20, right: 20, bottom: 50, left: 50}}
                           containerComponent={<VictoryVoronoiContainer/>} domainPadding={20}>
               <VictoryAxis
                 label="Share of Open Ideas (%)"
                 dependentAxis
                 domain={dataForChart.yDomain}
               />
               <VictoryAxis
                 label="% Long"
                 domain={dataForChart.xDomain}
               />
               <VictoryScatter
                 labelComponent={<CustomLabel/>}
                 data={dataForChart.sectorData}
                 x="percentageLong"
                 y="percentageOfOpenIdeas"
                 size={5}
                 labels={d=>d.name}
               />
               {dataForChart.tails.map(data => <VictoryLine key={data[0].name} data={data} y="percentageOfOpenIdeas" x="percentageLong"/>)}
             </VictoryChart>
           </div>;
};

export default SectorsBubbleChart;
